module.exports = __webpack_public_path__ + "img/ico-ig.0d9fe4d1.svg";